///<reference path="../common/smart-mover.models.ts"/>
///<reference path="data-template-list.d.ts"/>


module Meevo.Components.Controls.SmartMover {

    export const DataTemplates: IDataTemplates = {
        reportEmployeeWithCategories: ReportEmployeeWitchCategoriesDataTemplate,
        reportEmployee: ReportSecureEmployeeDataTemplate,
        reportEmployeeCategories: ReportEmployeeCategoryDataTemplate,
        reportEmployeesNonUsers: ReportEmployeesNonUsersDataTemplate,
        reportManufacturers: ReportManufacturersDataTemplate,
        reportDistributor: ReportDistributorDataTemplate,
        reportDistributorInventoryReturn: ReportDistributorInventoryReturnsDataTemplate,
        reportDistributorPurchaseOrder: ReportDistributorPurchaseOrder,
        reportPointPromotions: ReportPointPromotionsDataTemplate,
        reportReferralTypes: ReportReferralTypesDataTemplate,
        reportDrawers: ReportDrawerMoverDataTemplate,
        reportPaymentTypes: PaymentTypesDataTemplate,
        reportUsers: ReportUsersDataTemplate,
        reportUsersNonEmployees: ReportUsersNonEmployeesDataTemplate,
        reportProductCategories: ReportProductCategoriesDataTemplate,
        reportServiceCategories: ReportServiceCategoriesDataTemplate,
        Liabilities: LiabilitiesDataTemplate,
        reportLiabilities: ReportLiabilitiesDataTemplate,
        reportPayrollEmployee: ReportPayrollEmployee,
        reportDP005ProductCategories: ReportDP005ProductsCategories,
        reportDP005ProductManufacturers: ReportDP005ProductsManufacturers,
        reportServicesWithCategories: ReportServicesWithCategories,
        locationsGeneric: LocationsGenericDataTemplate,
        reportFloorLocations: ReportFloorLocationsDataTemplate,
        servicesWithCategories: ServicesWithCategories,
        memberships: MembershipsDataTemplate,
        giftCardTypes: GiftCardTypesDataTemplate,
        packageTypes: PackageTypesDataTemplate,
        productVariants: ProductVariantsDataTemplate,
        discountFees: DiscountFeesDataTemplate,
        productVariantsManufacturers: ProductVariantsManufacturersDataTemplate,
        reportStudentsAndTeachers: ReportStudentsAndTeachers,
        reportTaxes: ReportTaxesDataTemplate,
        users: UsersDataTemplate,
        employees: EmployeesDataTemplate,
        textelEmployeesWithCategories: TextelEmployeesWithCategoriesDataTemplate,
        CSEEmployeesWithCategoriesDataTemplate: CSEEmployeesWithCategoriesDataTemplate,
        CSEProductsWithCategoriesDataTemplate: CSEProductsWithCategoriesDataTemplate,
        CSEServicesWithCategoriesDataTemplate: CSEServicesWithCategoriesDataTemplate,
        salesRankingEmployees: SalesRankingEmployeeDataTemplate,
        reportCoreLocations: ReportCoreLocationsDataTemplate,
        reportLocationGroups: ReportLocationGroupsDataTemplate,
        employeesWithCategories: EmployeesWithCategories,
        resourcesWithCategories: ResourcesWithCategories,
        reportManufacturersProdCats: ReportManufacturersProdCats,
        reportProdCatsManufacturers: ReportProdCatsManufacturers,
        membershipsWithTypes: MembershipsWithTypesDataTemplate,
        clientTypes: ClientTypesDataTemplate,
        distributor: DistributorDataTemplate,
        inventoryManufacturers: InventoryManufacturersDataTemplate,
        inventoryDistributors: InventoryDistributorsDataTemplate,
        inventoryProductCategories: InventoryProductCategoriesDataTemplate,
        ymMemberships: YMMembershipsDataTemplate,
        reportVisitNoteType: ReportVisitNoteType,
        purchaseOrderProductCategories: PurchaseOrderProductCategoriesDataTemplate,
        purchaseOrderSupplyCategories: PurchaseOrderSupplyCategoriesDataTemplate,
        purchaseOrderManufacturers: PurchaseOrderManufacturersDataTemplate,
        reportTeacherWithCategories: ReportTeacherWithCategoriesDataTemplate,
        reportStudentWithCategories: ReportStudentWithCategoriesDataTemplate,
        reportEmployeeOnlyWithCategories: ReportEmployeeOnlyWithCategoriesDataTemplate,
        productVariantsWithCategories: ProductWithCategoriesTemplate,
        productWithCategoriesAndBundles: ProductsWithCategoriesAndBundles,
        docsAndFormsTemplate: DocsAndFormsDataTemplate,
        alertsManagerEmployee: AlertsManagerEmployee,
        alertsManagerServiceWithCategories: AlertsManagerServiceWithCategoriesTemplate,
        alertsManagerEmployeeConfiguration: AlertsManagerEmployeeConfigurationTemplate,
        reportEmployeeStudentTeacher: ReportEmployeeStudentTeacherDataTemplate,
        serviceCategories: ServiceCategoriesDataTemplate,
        productCategories: ProductCategoriesDataTemplate,
        reportResourcesWithCategories: ReportResourcesWithCategories,
        alertsManagerUser: AlertsManagerUserTemplate,
        reportMerchantAccount: ReportMerchantAccountsDataTemplate
    };
}
